import { Program } from '~source/core/models/tv-guide';
import { isLiveProgram } from '~source/utils/is-live-program';

const isProgramFuture = (program: Program): boolean => {
    const now = new Date();
    const startDate = new Date(program.dateStart);

    // Programs before 7am that are on the next day should be treated as part of today
    // This handles the case where programs before 7am are wrapped to the end of today's timeline
    // but have tomorrow's date in the data
    const startHour = startDate.getHours();
    const startMinutes = startDate.getMinutes();
    const startTimeOfDay = startHour * 60 + startMinutes; // minutes from midnight
    const sevenAM = 7 * 60; // 420 minutes from midnight

    // If program starts before 7am, normalize it to today's date for comparison
    let normalizedStartDate = startDate;
    if (startTimeOfDay < sevenAM) {
        const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
        normalizedStartDate = new Date(today);
        normalizedStartDate.setHours(
            startHour,
            startMinutes,
            startDate.getSeconds(),
            startDate.getMilliseconds(),
        );
    }

    const isFuture = normalizedStartDate.getTime() > now.getTime();
    return isFuture;
};

const isProgramReplay = (program: Program): boolean => {
    const now = new Date();
    const endDate = new Date(program.dateEnd);
    return endDate.getTime() < now.getTime();
};

export const buildEpgWebUrl = (program: Program): string | null => {
    // Future: no navigation
    if (isProgramFuture(program)) {
        return null;
    }

    // Live: go to channel live
    if (isLiveProgram(program)) {
        return `/live/${program.channelId}`;
    }

    if (program.serial) {
        const base = `/live/${program.channelId}/${encodeURIComponent(program.serial)}`;
        if (typeof program.event === 'number') {
            return `${base}/${encodeURIComponent(String(program.event))}`;
        }
        return base;
    }

    if (isProgramReplay(program)) {
        return `/live/${program.channelId}`;
    }

    return `/live/${program.channelId}`;
};

export const navigateToEpgWebUrl = (program: Program): void => {
    const href = buildEpgWebUrl(program);
    if (!href) return;
    window.location.href = href;
};
